import { createContext, useContext } from "react";

export interface AuthAccount {
  userId: string | null;
  userDetails: string | null;
  userRoles: string[];
  identityProvider: string | null;
}

export interface AuthContextValue {
  isAuthenticated: boolean;
  loading: boolean;
  isAuthBypassed: boolean;
  login: () => Promise<void>;
  logout: () => Promise<void>;
  getAccessToken: (scopes?: string[]) => Promise<string | null>;
  account: AuthAccount | null;
}

export const AuthContext = createContext<AuthContextValue | undefined>(
  undefined,
);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
}
